<template>
  <div :style="{width:width+'px',height:height+'px'}" :id="uuid"></div>
</template>

<script setup>
import {getDataJson, pollingRefresh,hasNonEmptyValues,hasProperty} from "@/utils/refresh-cpt-data";
import {registerMap} from "@/utils/map-manage";
import {fileUrl} from "/env";
import {onMounted, watch, computed} from "vue";
import * as echarts from 'echarts'
// import chinaGeoJson from '@/assets/map/china.json'
const loadChinaGeoJson = async () => {
     const { default: chinaGeoJson } = await import('@/assets/map/china.json');
     return chinaGeoJson;
   };

const props = defineProps({
  width:Number,
  height:Number,
  option:Object,
  components:Array,
  current: Object
})
// 新增属性兼容旧代码
const attr = props.option.attribute
if (!attr.globalDataReload) attr.globalDataReload = [0]

let dataReload = computed(() => props.option.attribute.globalDataReload || [0])
watch(() => props.current.cptShow,(val)=>{
    if (val && dataReload.value.includes(1)) {
      refreshCptData();
    }
  })
  watch(() => props.option.attribute.hideCompInTabw,(val)=>{
    if (!val && dataReload.value.includes(1)) {
      refreshCptData();
    }
  })
watch(() => props.option.attribute, (obj) => {
  processData(props.option.cptDataForm,newData,jsFunFlag)
  loadChart(obj);
},{deep:true})
watch(() => [props.width,props.height], () => {
  chart.resize()
})

let uuid = require('uuid').v1();
let chartOption = {};
let chart = null
let cptData = [];
let newData = "";
let jsFunFlag = false;
const emit = defineEmits(['clickHandler'])

onMounted(()=>{
  // echarts.registerMap('china', chinaGeoJson);
  // let element = document.getElementById(uuid)
  // if(!element) {
  //   return
  // }
  // chart = echarts.init(element)
  // refreshCptData(props.option.cptDataForm)

  loadChinaGeoJson().then(chinaJson => {
    echarts.registerMap('china', chinaJson);
    let element = document.getElementById(uuid)
    if(!element) {
      return
    }
    chart = echarts.init(element)
    if (dataReload.value.includes(0)) {
      refreshCptData();
    }
  });
})

function refreshCptData(cptDataForm = props.option.cptDataForm,paras){
  pollingRefresh(uuid, cptDataForm, () => loadData(cptDataForm,paras),
  props.components)
}
function loadData(cptDataForm,paras){
  getDataJson(cptDataForm,paras,(res)=> {
        // cptData = res;
        newData = cptDataForm.dataSource == '4' && hasProperty(res,'jsFunction') ? res.resStr : res;//相同数据集只调用一次接口原因
        jsFunFlag = cptDataForm.dataSource == '4' && hasProperty(res,'jsFunction') ? res.jsFunction : false;//相同数据集只调用一次接口原因
        processData(cptDataForm,newData,jsFunFlag)
        loadChart(props.option.attribute);

      })
}
function processData(cptDataForm,res,jsFunFlag){
          // 第一层判断 如果选择数据集
          if(cptDataForm.dataSource == '4') {
            // 第二层判断 ，如果没有配转换脚本
            if(jsFunFlag) { // 没有全部配置映射字段
                if(hasNonEmptyValues(props.option.attribute.cptTableData)) {
                    const dataKey = props.option.attribute.cptTableData;
                    console.log(res,'res')
                    let newarr = {
  lines: [],
  bars: [],
  mapData: []
};

// 键值映射对象
const dataKeyMap = dataKey.reduce((acc, curr) => {
  acc[curr.namekey] = curr.value;
  return acc;
}, {});

// 遍历 map 数组并填充 newarr
res.forEach(item => {
  const type = item[dataKeyMap.type];
  
  switch (type) {
    case 'line':
      let lineItem = {};
      lineItem.start = item[dataKeyMap.start].split(',').map(Number);
      lineItem.end = item[dataKeyMap.end].split(',').map(Number);
      newarr.lines.push(lineItem);
      break;
    case 'bar':
      let barItem = {};
      barItem.name = item[dataKeyMap.name];
      barItem.lct = item[dataKeyMap.start].split(',').map(Number);
      barItem.value = item[dataKeyMap.value] || null;
      newarr.bars.push(barItem);
      break;
    case 'mapData':
      let mapDataItem = {};
      mapDataItem.name = item[dataKeyMap.name];
      mapDataItem.value = item[dataKeyMap.value] || null;
      newarr.mapData.push(mapDataItem);
      break;
  }
});

console.log(newarr,'新数组')
           cptData = newarr; 
              }
             } else { // 如果配置了转换脚本
             console.log(res,'*')
                cptData = res;
             }
          } else { // 不是数据集类型，是静态数据
            console.log(res,'*')
               cptData = res;
          } 
  }
function loadChart(attribute) {
  if(!cptData) return;
  // const symbol = 'path://M1705.06,1318.313v-89.254l-319.9-221.799l0.073-208.063c0.521-84.662-26.629-121.796-63.961-121.491c-37.332-0.305-64.482,36.829-63.961,121.491l0.073,208.063l-319.9,221.799v89.254l330.343-157.288l12.238,241.308l-134.449,92.931l0.531,42.034l175.125-42.917l175.125,42.917l0.531-42.034l-134.449-92.931l12.238-241.308L1705.06,1318.313z';
  const symbol = attribute.customScatter.symbol ? fileUrl + attribute.customScatter.symbol : require('@/assets/map/building.png')
  let visualMap = JSON.parse(JSON.stringify(attribute.visualMap))
  for (let i = 0; i < visualMap.pieces.length; i++) {
    visualMap.pieces[i].color = attribute.color[i]
  }

  let barData = [], linesData = [], scatterData = new Set();
  if(cptData.bars){
    cptData.bars.forEach(bar => {
      barData.push({name:bar.name,value:bar.lct,num:bar.value})
    })
  }
  if(cptData.lines){
    cptData.lines.forEach(line => {
      linesData.push([line.start,line.end])
      scatterData.add(line.end)//小圆点
    })
  }
  registerMap(attribute.provinceCode,attribute.cityCode).then(cityCode => {
    chartOption = {
      title : attribute.title,
      tooltip : {
        trigger: 'item',
        formatter: function(param) {
          if(!param.data){
            return param.name
          }
          return param.data.name+': '+(param.data.num || param.data.value || '')
        }
      },
      geo: {
        map: cityCode,
        silent: true,
        z:0,
        zoom: 1.23,
        aspectScale: attribute.map.aspectScale,
        // roam: true,
        itemStyle: {
          shadowColor: attribute.map.shadowColor,
          shadowBlur: attribute.map.shadowBlur,
          shadowOffsetX: attribute.map.shadowOffsetX,
          shadowOffsetY: attribute.map.shadowOffsetY,
        }
      },
      visualMap: visualMap,
      series: [
        {
          name: '-',
          type:'map',
          zlevel: 1,
          map: cityCode,
          zoom: 1.23,
          aspectScale: attribute.map.aspectScale,
          roam: false,//禁止缩放
          label: {
            show: attribute.map.showLabel,
            fontSize: attribute.map.fontSize,
            color: attribute.map.color
          },
          itemStyle: {
            areaColor: attribute.map.areaColor,
            borderColor: attribute.map.borderColor
          },
          data: cptData.mapData,
        },
        {
          show: attribute.effectScatter.show,
          type: 'effectScatter',
          coordinateSystem: 'geo',
          zlevel: 2,
          rippleEffect: attribute.effectScatter.rippleEffect,
          label: attribute.effectScatter.label,
          symbolSize: [attribute.effectScatter.symbolSize * attribute.effectScatter.symbolScale,attribute.effectScatter.symbolSize],
          itemStyle: attribute.effectScatter.itemStyle,
          emphasis:{
            itemStyle:{
              color:'#ff0'
            }
          },
          data: barData,
        },
        {
          type: 'scatter',
          coordinateSystem: 'geo',
          symbol: 'image://'+symbol,
          symbolSize: attribute.customScatter.symbolSize,
          symbolOffset: [attribute.customScatter.symbolOffsetX, attribute.customScatter.symbolOffsetY],
          itemStyle:{
            opacity:1
          },
          zlevel: 10,
          data: barData,
        },
        {
          type: 'scatter',
          coordinateSystem: 'geo',
          symbolSize: attribute.line.endPoint.symbolSize,
          zlevel: 10,
          itemStyle: attribute.line.endPoint.itemStyle,
          data: Array.from(scatterData),
          tooltip: {
            show: false
          }
        }
      ]
    }
    if(attribute.line.show){//飞线
      chartOption.series = chartOption.series.concat({
        name: attribute.seriesName,
        type: 'lines',
        zlevel: 12,
        lineStyle: attribute.line.lineStyle,
        effect: attribute.line.effect,
        data: linesData,
        tooltip: {show:false}
      })
    }
    chart.setOption(chartOption, true);
    chart.on('click', (params) => {
      emit("clickHandler",props.option.interaction,'default',params.name)
    })
  });
}

defineExpose({refreshCptData})
</script>

<style scoped>

</style>
